import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { HttpClient } from '../../../services/http.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-action-views-modal',
    templateUrl: './action-views-modal.component.html',
    styleUrls: ['./action-views-modal.component.scss'],
    standalone: false
})
export class ActionViewsModalComponent implements OnInit, OnDestroy {

  @Input() public id;

  public viewsCount: any = null;
  public viewsTimeAverage: any = null;

  public actionViewsRows: any = {};

  public filter: any = {};

  public form: UntypedFormGroup;
  private formSubscription: Subscription;

  constructor(private http: HttpClient,
              private fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      'date_from': [''],
      'date_to': [''],
    });
    this.loadStatistic();
    this.loadData();

    this.formSubscription = this.form.valueChanges.subscribe(value => {
      this.loadData();
    });
  }

  loadStatistic() {
    this.http.post('ActionBanners.get_action_view_statistic', {'id': this.id})
      .subscribe(
        (response) => {
          this.viewsCount = response.views_count;
          this.viewsTimeAverage = response.views_time_average;
        },
        (error) => false
      );
  }

  loadData() {
    const filter = this.form?.value || {};

    this.http.post('ActionBanners.get_views', {
      'id': this.id,
      filter: {
        date_from: filter.date_from || null,
        date_to: filter.date_to || null
      }
    })
      .subscribe(
        (response) => {
          this.actionViewsRows = response.rows;
        },
        (error) => false
      );
  }

  ngOnDestroy() {
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

}
